import React from "react";
import bubbleIcon from "assets/answer-bubble-icon-2x.png";
import computerIcon from "assets/score-reports-grey-icon.png";
import "./index.scss";
import classNames from "classnames";

interface IProps {
  type: "online" | "bubble";
  theme:"light"|"dark";
}

export const PracticeMobileModalIcon = ({ type,theme }: IProps) => {
  return (
    <div className={classNames("modal-icon-wrapper",`${theme}`)}>
      <img src={type === "online" ? computerIcon : bubbleIcon} alt="" />
    </div>
  );
};
